import { render, staticRenderFns } from "./consultationRecord.vue?vue&type=template&id=7d6137a0&scoped=true"
import script from "./consultationRecord.vue?vue&type=script&lang=js"
export * from "./consultationRecord.vue?vue&type=script&lang=js"
import style0 from "./consultationRecord.vue?vue&type=style&index=0&id=7d6137a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6137a0",
  null
  
)

export default component.exports